export const branding = {
    id: 1,
    name: "Default",
    description: "The default Propel branding.",
    createdUtc: "2018-06-20T15:19:33Z",
    updatedUtc: "2018-06-20T15:19:33Z",
    deletedUtc: null,
    isDeleted: false,

    productName: "Propel TMS",
    domainName: "propel.example.com",
    supportEmailAddress: "support@example.com",
    supportPhoneNumber: "(530)555-0120",

    majorLogoUrl: "/logo_major.svg",
    minorLogoUrl: "/logo_minor.svg",
    poweredByUrl: "/powered_by.png",

    frontendPrimaryColor: "#00a1fb",
    frontendPrimaryDarkerColor: "#2e72d2",
    frontendPrimaryLightColor: "#e0f3fe",

    // same as primary
    frontendSecondaryColor: "#00a1fb",
    frontendSecondaryDarkerColor: "#2e72d2",
    frontendSecondaryLightColor: "#e0f3fe",

    navigationColor: "#002940",
    navigationActiveColor: "#1f4357",
    navigationHoverColor: "#1f4357",

};

export const mocks = {
    Branding: () => branding,
};

export const resolvers = {
    BrandingQueries: {
        all: () => [branding],
        byId: () => branding,
        defaultBranding: () => branding,
    },
};
